// src/router.js
import { createRouter, createWebHistory } from 'vue-router';

import { useUserStore } from '@/stores/userStore';
import preloginRoutes from './prelogin';
import postloginRoutes from './postlogin';
import adminRoutes from './adminRoutes';

// Define all routes
const routes = [
  ...preloginRoutes,
  ...postloginRoutes,
  ...adminRoutes,
  // 404 Route
  {
    path: '/:pathMatch(.*)*',
    redirect: '/coming-soon',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// Global Route Guard
router.beforeEach((to, from, next) => {
  const userStore = useUserStore();

  // Check for protected /app routes
  if (to.path.startsWith('/app')) {
    if (!userStore.isLoggedIn) {
      next({ path: '/' }); // Redirect unauthenticated users to login
    } else {
      if (to.matched.some(record => record.meta.requiresAuth)) {
        if (userStore.getuserType === 0) {
          next({ path: '/' }); // Restricted for unauthorized user types
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
  // Check for protected /admin routes
  else if (to.path.startsWith('/admin/')) {
    if ( userStore.getuserType !== 'admin') {
    // if (userStore.getuserType == 'admin') {
      next({ path: '/' }); // Redirect if not logged in or not an admin
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
